import React from "react"
import { FormattedMessage } from "react-intl"
// Material Ui
import Button from "@material-ui/core/Button"
import { propTypes, outlinedDefault } from "./ButtonPropTypes"

const ButtonCancel = (props) => (
  <Button {...props}>
    <FormattedMessage defaultMessage="Cancel" id="word.cancel" />
  </Button>
)

ButtonCancel.propTypes = propTypes
ButtonCancel.defaultProps = outlinedDefault

export default ButtonCancel
